export enum Namespaces {
    notice = "notice",
}
